import TYPES from './types';
import resourceId from '~/misc/resourceId';
import get from 'lodash/get'
import keyBy from 'lodash/keyBy';
import fromPairs from 'lodash/fromPairs'
import {checked, checkedAll, confirmCheckedAll} from '~/misc/checked';
import {statistyChecked} from '~/misc/checked';
const initialState = {
  status: 'ok',
  results: {
    shipments: [],
    total_shipments: 0,
  },
  noneResults: true,
  hasItems: false,
  itemsIndex: {},
  total: 500,
  showCount: 50,
  orderIndex: {},
  originalList: [],
};

const getCountPairs = (item, i) => ([item.id, i]);
const getOrderIndex = (main, added) =>
  fromPairs([].concat(
    main.map(getCountPairs),
    added.map(getCountPairs)
  ));

const getResourceIdentity = (queryCompleted) => resourceId('cityRatioList', {
  query: queryCompleted,
});

const reducer = (state, action) => {
  switch (action.type) {
    case TYPES.CITYRATIO_LIST_CRITERIA: {
      const data = action.payload;

      return {
        query: data,
        status: null,
        identity: getResourceIdentity(data),
      };
    }
    case TYPES.CITYRATIO_LIST_GET:  {

      if (action.error) {
        return {
          status: 'error',
        };
      }

      if (action.pending) {
        return {
          status: (()=>{
            switch(action.type){
              case TYPES.CITYRATIO_LIST_SORT:
                return "sort"
              case TYPES.CITYRATIO_LIST_GET:
                return "loading"
            }
          }),
          results: action.type === TYPES.CITYRATIO_LIST_SORT ? state.results : null,
          total: action.type ===  TYPES.CITYRATIO_LIST_SORT ? 500 : null,
          showCount: action.type ===  TYPES.CITYRATIO_LIST_SORT ? 50 : null,
        };
      }

      if (!action.payload) {
        return {
          status: 'ok',
          results: {
            shipments: [],
            total_shipments: 0,
          },
          noneResults: true,
          hasItems: false,
          itemsIndex: {},
          total: 0,
          showCount: 0,
          orderIndex: {},
        };
      }

      const payloadList = (action.payload.shipments || []).map(item => ({
        ...item,
        identity: resourceId('cityRatioListItem', {
          id: item.id,
        }, state.identity),
        parentIdentity: state.identity,
        checked: false,
      }));

      const sliced = payloadList.slice(0, 50);

      const checkedAll = confirmCheckedAll(payloadList);
      return {
        status: 'ok',
        results: {
          ...action.payload,
          shipments: sliced,
        },
        noneResults: false,
        hasItems: Boolean(get(action, 'payload.shipments.length')),
        total: Math.min(payloadList.length, 500),
        showCount: 5,
        originalList: payloadList,
        itemsIndex: keyBy(payloadList, 'id'),
        orderIndex: getOrderIndex(payloadList, []),
        checkedAll,
        checked: statistyChecked(payloadList),
      };
    }
    case TYPES.CITYRATIO_CHECKED: {
      return checked(action.payload.id, state);
    }
    case TYPES.CITYRATIO_CHECKED_ALL: {
      return checkedAll(state);
    }
    case TYPES.CITYRATIO_CLEAR_CHECKED: {
      return {
        checkedAll: false,
      };
    }
    case TYPES.CITYRATIO_UPDATE_CHECKED: {
      const fullList = state.results.shipments;
      return {
        checked: statistyChecked(fullList),
      };
    }
    case TYPES.CITYRATIO_SHOW_MORE: {
      const fullList = state.originalList;
      return {
        showCount: state.showCount + action.payload,
        results: {
          ...state.result,
          shipments: fullList.slice(0, state.showCount + action.payload),
        },
      }
    }
  }
  return null;
}

export default {reducer, initialState};


// WEBPACK FOOTER //
// ./src/modules/cityRatioList/reducer.js